import { render } from "./SalesCard.vue?vue&type=template&id=105ccee8&scoped=true&bindings={}"
import script from "./SalesCard.vue?vue&type=script&lang=ts"
export * from "./SalesCard.vue?vue&type=script&lang=ts"

import "./SalesCard.vue?vue&type=style&index=0&id=105ccee8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-105ccee8"

export default script